// These consts should match PDFGen
const FXFONT_BOLD = 1 << 18;
const FXFONT_FIXED_PITCH = 1 << 0;
const FXFONT_ITALIC = 1 << 6;
export function transformFont(font) {
    const commaPosition = font.n.lastIndexOf(',');
    const baseFont = commaPosition > -1 ? font.n.substr(0, commaPosition) : font.n;
    const substitution = font.f & FXFONT_FIXED_PITCH ? 'monospace' : 'serif';
    const fontFamily = `"${baseFont}", ${substitution}`;
    return { fontFamily, isBold: (font.f & FXFONT_BOLD) > 0, isItalic: (font.f & FXFONT_ITALIC) > 0 };
}
const getArchiveEntries = (resp, parentPath = '') => {
    var _a, _b, _c, _d;
    // The root entry is encoded as the empty string by getSubpath
    const fileName = resp.name === '/' ? '' : resp.name;
    const currentPath = resp.name === '/' ? '' : `${parentPath}/${resp.name}`;
    const childEntries = (_b = (_a = resp.children) === null || _a === void 0 ? void 0 : _a.reduce((entries, child) => ({
        ...entries,
        ...getArchiveEntries(child, currentPath),
    }), {})) !== null && _b !== void 0 ? _b : undefined;
    const currentEntry = resp.isDir
        ? {
            isDir: true,
            children: (_d = (_c = resp.children) === null || _c === void 0 ? void 0 : _c.map((child) => child.name)) !== null && _d !== void 0 ? _d : [],
            name: fileName,
            size: undefined,
        }
        : {
            isDir: false,
            size: resp.size ? Number(resp.size) : 0,
            name: fileName,
            children: undefined,
        };
    return {
        ...childEntries,
        [currentPath]: currentEntry,
    };
};
export const transformArchiveTreeResponseToArchiveRootEntry = (resp) => ({
    entries: getArchiveEntries(resp),
    isPasswordProtected: !!resp.isEncrypted,
});
//# sourceMappingURL=transform.preenvesnextjs.map
